export default __webpack_public_path__ + "static/latency1-dc96d9c4fb8beb3151f1ca2ed1be8f30.png";